import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { useRef, useState } from 'react';
const defaultText = (_jsxs("span", { children: ["Drop your images here, or ", _jsx("span", { className: "text-violet-60", children: "click to browse" })] }));
const FileUploadField = ({ onFileChosen, filetypes, errorMessage, className, text = defaultText, placeholder = '', multiple = false, }) => {
    const inputRef = useRef(null);
    const [fileUploadError, setFileUploadError] = useState(false);
    const handleFileUpload = (e) => {
        const fileList = e.target.files;
        if (fileList) {
            onFileChosen(Array.from(fileList));
        }
    };
    const handleFileDrop = (e) => {
        setFileUploadError(false);
        e.preventDefault();
        const files = [];
        if (e.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (e.dataTransfer.items[i].kind === 'file') {
                    const file = e.dataTransfer.items[i].getAsFile();
                    if (file && filetypes.indexOf(file.type) > -1) {
                        files.push(file);
                    }
                }
            }
        }
        else {
            // Use DataTransfer interface to access the file(s)
            for (let i = 0; i < e.dataTransfer.files.length; i++) {
                if (filetypes.indexOf(e.dataTransfer.files[i].type) > -1) {
                    files.push(e.dataTransfer.files[i]);
                }
            }
        }
        if (files.length === 1) {
            onFileChosen(files);
        }
        else {
            setFileUploadError(true);
        }
    };
    return (_jsxs("div", { onClick: () => inputRef?.current?.click(), onDrop: handleFileDrop, onDragOver: (e) => e.preventDefault(), className: clsx('inter-base-regular text-grey-50 rounded-rounded border-grey-20 hover:border-violet-60 hover:text-grey-40 flex h-full w-full cursor-pointer select-none flex-col items-center justify-center border-2 border-dashed transition-colors', className), children: [_jsxs("div", { className: "flex flex-col items-center", children: [_jsx("p", { children: text }), placeholder] }), fileUploadError && _jsx("span", { className: "text-rose-60", children: errorMessage || 'Please upload an image file' }), _jsx("input", { ref: inputRef, accept: filetypes.join(', '), multiple: multiple, type: "file", onChange: handleFileUpload, className: "hidden" })] }));
};
export default FileUploadField;
//# sourceMappingURL=index.js.map